import request from '@/utils/request'
/**
 *
 * 收据管理
 *
 **/

export const getReceipts = (params: any) =>
  request({
    'url': `/consultant/Receipt/pageQuery`,
    'method': 'GET',
    params
  })


// 导出收据pdf
export function exportReceipt(receiptId: number, params: any) {
  return request({
    url: `/consultant/Receipt/${receiptId}/export`,
    method: 'get',
    responseType: "blob",
    params
  })
}

// 获取客单学生姓名列表
export const getClienteleStuNames = (params: any) =>
  request({
    'url': `/consultant/Receipt/getStuNames`,
    'method': 'GET',
    params
  })

export const addReceipt = (data: any) =>
  request({
    'url': `/consultant/Receipt`,
    'method': 'POST',
    data
  })

// 获取年份列表
export const getYears = (params: any) =>
  request({
    'url': `/consultant/Receipt/getTransactionYears`,
    'method': 'GET',
    params
  })

// 获取交易概览信息
export const getTransctionsInfo = (params: any) =>
  request({
    'url': `/consultant/Receipt/getTransactionInfo`,
    'method': 'GET',
    params
  })
// 获取当前收据信息（修改）
export const getCurrentReceipt = (params: any) =>
  request({
    'url': `/consultant/Receipts/getReceiptById`,
    'method': 'GET',
    params
  })

// 修改当前收据信息
export const updateReceipt = (data: any) =>
  request({
    'url': `/consultant/Receipts/updateReceipt`,
    'method': 'PUT',
    data
  })

// delReceipts
// 删除选中收据
export const delReceipts = (params: any) =>
  request({
    'url': `/consultant/Receipts/delReceipt`,
    'method': 'DELETE',
    params
  })

// ----------------------------------------------------------------------------

